import React, { memo, useCallback } from 'react'
import { Button, Col, Row, Tooltip } from 'antd'
import produce from 'immer'
import { map } from 'lodash'
import PropTypes from 'prop-types'

import { labelLegendPropType } from '../../prop-types'
import { StyledQaCorrectionsIcon } from '../styled'

import LabelLegendRow from './label-legend-row'

const LabelLegends = ({
  type,
  labelLegends,
  options,
  onChange,
  isDisabled,
  showAddButton,
  isQaCorrected,
}) => {
  const handleChange = useCallback(
    (index, updatedLabelLegend) =>
      onChange(
        produce(labelLegends, draft => {
          draft[index] = updatedLabelLegend
        }),
      ),
    [labelLegends, onChange],
  )

  const handleDelete = useCallback(
    index => {
      onChange(
        produce(labelLegends, draft => {
          draft.splice(index, 1)
        }),
      )
    },
    [labelLegends, onChange],
  )

  const handleAdd = useCallback(() => {
    const updatedLabelLegends = [
      ...labelLegends,
      {
        label: '',
        [`${type}Id`]: options?.[0]?.value,
      },
    ]
    onChange(updatedLabelLegends)
  }, [type, labelLegends, onChange, options])

  return (
    <Row>
      <Col span={24}>
        {map(labelLegends, (labelLegend, index) => (
          <LabelLegendRow
            index={index}
            key={labelLegend.id}
            labelLegend={labelLegend}
            options={options}
            type={type}
            isDisabled={isDisabled}
            onChange={handleChange}
            onDelete={handleDelete}
          />
        ))}
      </Col>

      {showAddButton && (
        <Col span={2} offset={2}>
          <Button disabled={isDisabled} onClick={handleAdd}>
            Add {type} legend
          </Button>
          {isQaCorrected && (
            <Tooltip title="This legend contains QA corrections">
              <StyledQaCorrectionsIcon />
            </Tooltip>
          )}
        </Col>
      )}
    </Row>
  )
}

LabelLegends.propTypes = {
  type: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelLegends: PropTypes.arrayOf(labelLegendPropType),
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  showAddButton: PropTypes.bool,
  isQaCorrected: PropTypes.bool,
}

LabelLegends.defaultProps = {
  labelLegends: [],
  onChange: undefined,
  showAddButton: true,
  isDisabled: false,
  isQaCorrected: false,
}

export default memo(LabelLegends)
